import apiClient from './apiConfig';

const walletService = {
  // Get wallet details with recent transactions
  getWallet: async () => {
    const response = await apiClient.get('/wallet');
    return response.data;
  },

  // Get wallet balance only
  getBalance: async () => {
    const response = await apiClient.get('/wallet/balance');
    return response.data;
  },

  // Initiate wallet top-up
  initiateTopUp: async (amount) => {
    const response = await apiClient.post('/wallet/topup', { amount });
    return response.data;
  },

  // Verify wallet top-up payment
  verifyTopUp: async (txRef) => {
    const response = await apiClient.get('/wallet/topup/verify', { params: { txRef } });
    return response.data;
  },

  // Get wallet transactions
  getTransactions: async (params = {}) => {
    const response = await apiClient.get('/wallet/transactions', { params });
    return response.data;
  },

  // Get wallet transaction summary
  getSummary: async () => {
    const response = await apiClient.get('/wallet/summary');
    return response.data;
  },
};

export default walletService;
